/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  var loading = 0;
  function loadNextPage(scrollURL){
    loading = 1;
    $.ajax({
		  type: 'GET',
		  url: scrollURL,
		  dataType: "html",
      success: function(data){
         var pageIndexParam = scrollURL.match(/\bpage=(\d+)/i);
			  var pageIndexOld = parseInt(pageIndexParam[1], 10);
			  var pageIndexNew = pageIndexOld + 1;
      scrollURL = scrollURL.replace('page=' + pageIndexOld, 'page=' + pageIndexNew);
			  $('.load-next-page').attr('data-url', scrollURL);
        $('.BlogPostsHolder').append(data);
  loading = 0;

        var totalPosts = $('.BlogPostsHolder').data('total');

        if($('.BlogPostsHolder').data('total') <= $('.BlogPostsHolder').find('.ArticleItem').length){
          $('.load-next-page').hide();
        }
      }
  })
  }



  function portfolioImages(){

    function updateFilters(){

      var finalString = '.portfolioImage';
      
      $('.filters-holder .vertical-select-field').each(function(){
         if($(this).find('input:checked').val() != '' && $(this).find('input:checked').val() != undefined){
           var attrName = $(this).data('attr');
           var attrValue = $(this).find('input:checked').val();

           finalString += '['+attrName+'*="'+attrValue+'"]';
         }

          $('.portfolioImage').hide();
        if($(finalString).length > 0){
          
          $('.no-relevant-content').hide();
          
          if(finalString != '.portfolioImage'){
             $('.load-more-data').hide();
          $(finalString).show();
          }
          else{
        $('.load-more-data').show();
            var parent = $('[data-section-type="portfolio-images"][data-content="content-section"]');
      var step = parent.data('max');
            
            $('.portfolioImage:lt('+step+')').show();
          }
        }
        else{
          $('.no-relevant-content').show();
        }
      })

      
      console.log('finalString: ' + finalString);
    }
    
    if($('[data-type="protfolio-blocks"]').length > 0){

      var htmlToAppend = '';

      $('[data-type="protfolio-blocks"]').each(function(){
       htmlToAppend = htmlToAppend + $(this).html();
      })

$('[data-section-type="portfolio-images"][data-content="content-section"] .contentHolder').append(htmlToAppend);
      
    }

var filterAttrs = {};

    
    $('.filters-holder .vertical-select-field').each(function(){
      filterAttrs[$(this).attr('data-attr')] = [];
    })

    console.log(filterAttrs.length);
    for(var i=0; i<filterAttrs.length;i++){
      console.log(filterAttrs[i]);
    }

    
    $('[data-section-type="portfolio-images"][data-content="content-section"] .portfolioImage').each(function(){
var elem = $(this);
          
$.each(Object.keys(filterAttrs), function(key, val){
var attrVal = elem.attr(val);

  console.log('attrVal: ',attrVal);

if(attrVal.indexOf(',') > -1){
  attrValSplit = attrVal.split(',');

  for(var i=0;i<attrValSplit.length;i++){
    console.log('attrValSplit:' + attrValSplit[i]);
    
      if(jQuery.inArray(attrValSplit[i], filterAttrs[val]) == -1){
    filterAttrs[val].push(attrValSplit[i]); 
  }
  }
}
  else{
  if(jQuery.inArray(attrVal, filterAttrs[val]) == -1){
    filterAttrs[val].push(attrVal); 
  }
  }
  

}) 
    })
    
    var optionTemplate = $('[data-type="option-template"]').html();
    //console.log(filterAttrs);
   $.each(Object.keys(filterAttrs), function(key, val){
console.log(filterAttrs[val].length, filterAttrs[val]);

     var parent = $('.vertical-select-field[data-attr="' + val + '"]');
     var name = parent.data('name');
     for(var i=0;i<filterAttrs[val].length;i++){
       var filterValue = filterAttrs[val][i];
var uniqueId = (val + i).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
       var optionHtml = optionTemplate.split('${name}').join(filterValue).split('${id}').join(uniqueId).split('${parentName}').join(name);

       parent.find('.options-holder').append(optionHtml);
     }
   })
    
    $('.load-more-data').click(function(){
      var parent = $('[data-section-type="portfolio-images"][data-content="content-section"]');
      var step = parent.data('max');

      var passedProds = 0;
      parent.find('.portfolioImage:hidden').each(function(){
        if(passedProds < step){
      console.log('step: ' + step + ';passedProds: ' + passedProds);
          $(this).show();
          passedProds++;
        }

      console.log('.portfolioImage:hidden: ' + parent.find('.portfolioImage:hidden').length);
        if(parent.find('.portfolioImage:hidden').length > 0){
          $('.load-more-data').show();
        }
        else{
          $('.load-more-data').hide();
        }
        
      })
    })

    $('.filters-holder .vertical-select-field input[type="radio"]').change(function(){
      updateFilters();
    })
  }

$('.parallax').each(function(){
    console.log('parallaxImg found');
  var img = $(this);
  var imgParent = $(this).parent();
  function parallaxImg () {
    console.log('parallaxImg triggered');
    var speed = img.data('speed');
    var imgY = imgParent.offset().top;
    var winY = $(this).scrollTop();
    var winH = $(this).height();
    var parentH = imgParent.innerHeight();


    // The next pixel to show on screen      
    var winBottom = winY + winH;

    // If block is shown on screen
    if (winBottom > imgY && winY < imgY + parentH) {
      // Number of pixels shown after block appear
      var imgBottom = ((winBottom - imgY) * speed);
      // Max number of pixels until block disappear
      var imgTop = winH + parentH;
      // Porcentage between start showing until disappearing
      var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
    }
    img.css({
      top: imgPercent + '%',
      transform: 'translate(-50%, -' + imgPercent + '%)'
    });
  }
  $(document).on({
    scroll: function () {
      parallaxImg();
    }, ready: function () {
      parallaxImg();
    }
  });
  parallaxImg();
});

function announcementFunction(){
        $('[data-section-type="announcement-bar"]').each(function(){

        
      var index = 1;
        var parent = $(this);
        var time = parent.data('time');
        setInterval(function(){
        
          index++;
          
          if(parent.find('.AnnouncementBar__Content[data-index="'+index+'"]').length == 0){
            
           index = 1;
          }
          
           parent.find('.AnnouncementBar__Content:not([data-index="'+index+'"])').slideUp(300);
            parent.find('.AnnouncementBar__Content[data-index="'+index+'"]').slideDown(300);
          
        }, time)
        
      })
}


function quickAddToCart(elem){

    var variantId = elem.attr('data-id');

    var formData = new FormData();
    
 formData.append('form_type', 'product');
 formData.append('utf8', '✓');
 formData.append('id', variantId);

    console.log(formData.entries());
    $.ajax({
        type: "POST",
        url: '/cart/add',
      processData: false, contentType: false,
        data: formData, // serializes the form's elements.
        success: function (data) {
          console.log("we made it!");

          $.post('/cart/update.js', { attributes : { "Gift wrap": "yes" } } ).done(function() {
    console.log( "second success" );
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            })
          );
  });
          
          
        }
      });
  
}

function removeFromCart(elem) {
  let variantId = elem.attr("data-id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
  }).then((data) => {
          console.log("we made it!");
              $.post('/cart/update.js', { attributes : { "Gift wrap": "" } } ).done(function() {
    console.log( "second success" );
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            })
          );
  });
    
  });
}
$(document).ready(function(){

announcementFunction();
  
var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        if (window.location.hash && isChrome) {

          var id = window.location.hash;

          if($(id).length == 1){
            $('html, body').animate({
        scrollTop: $(id).offset().top
    }, 500);
          }
        }
  
 window.dispatchEvent(new Event('resize'));

  $('.loadMorePosts').click(function(){
    var scrollURL = $('.load-next-page').attr('data-url');
              
        loadNextPage(scrollURL);
  })

  if($('[data-section-type="portfolio-images"]').length > 0){
    portfolioImages();
  }

  
    $(document).on('mouseup', '.vertical-select-field:visible .current-option', function(e){
        var this1 = e.target;
        $('.vertical-select-field').removeClass('current');
        $(this1).parents('.vertical-select-field').addClass('current');
        console.log('needed length: ' + $(this1).parents('.vertical-select-field').length);
        $('.vertical-select-field:not(.current)').find('.options-holder').slideUp(300);
        $(this1).parents('.vertical-select-field').find('.options-holder').slideToggle(300);

    })

    $(document).mouseup(function(e) {
        var container = $(".vertical-select-field");
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            container.find('.options-holder').slideUp(300);
            container.removeClass('current');
            console.log('closing it');

        }
    });

    $(document).on('mouseup', '.vertical-select-field .option:not(.current-option)', function(){
        var parent = $(this).parents('.vertical-select-field');
        $('.vertical-select-field .options-holder').slideUp(300);
        parent.find('.option').removeClass('active');
        $(this).addClass('active');
        parent.find('.current-option .option-name').html($(this).data('name'));
        parent.removeClass('current');
        console.log('closing it 2');
    })

  $('.Modal.Modal--fullScreen.Modal--dark').click(function(e){

     if (e.target === this){

       $(this).find('.Modal__Close').trigger('click');
     }
  })

  $(document).on('change', '.giftWrapBox', function(){

    var elem = $(this);
    
    var variantId = elem.data('id');
    
    if(elem.is(':checked')){
       quickAddToCart(elem);
    }
    else{
console.log('element not checked. .CartItem[data-id="'+variantId+'"]: ', $('.CartItem[data-id="'+variantId+'"]').length)
if($('.CartItem[data-id="'+variantId+'"]').length > 0){
  removeFromCart($('.CartItem[data-id="'+variantId+'"]'))
}
      
    }
    
  })
    
})
